import "../../cssfiles/mainpage/Line.css";

const Line = () => {
  return <div className="line-container" aria-hidden="true" />;
};

export default Line;